import { render } from "./deviceDelivery.vue?vue&type=template&id=0ba45f35&scoped=true"
import script from "./deviceDelivery.vue?vue&type=script&lang=js"
export * from "./deviceDelivery.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba45f35"]])

export default __exports__